/* LEVEL interactive terpene wheel.
   Reusable blog element. Drop <div id="level-terpene-wheel"></div> into any
   article body; this script (loaded on article pages via theme.liquid) renders
   the whole module into it. Paired with terpene-wheel.css. Self-guards, so
   articles without the mount div are unaffected. */
(function(){
  function init(){
    var root=document.getElementById('level-terpene-wheel');
    if(!root || root.dataset.twInit==='1') return;
    root.dataset.twInit='1';
    root.classList.add('terp');

    var TERPENES = [
      {name:"Limonene", short:"Limonene", family:"Citrus", aroma:"Bright, zesty citrus peel", found:["Lemon & orange peel","Juniper","Peppermint"], note:"One of the most abundant terpenes in nature — the same compound that makes a fresh-peeled orange smell the way it does. Widely studied for its bright, uplifting scent profile."},
      {name:"Valencene", short:"Valencene", family:"Citrus", aroma:"Sweet, fresh orange", found:["Valencia oranges","Grapefruit","Tangerine"], note:"Named after the Valencia orange it was first isolated from. A clean citrus top-note used across perfumery and food flavoring."},
      {name:"Terpinolene", short:"Terpinolene", family:"Herbal", aroma:"Fresh, herbal, piney-floral", found:["Nutmeg","Apple","Cumin","Lilac"], note:"A complex, multi-layered aroma that rarely appears in large amounts. It sits at the crossroads of floral, herbal and woody, which makes it hard to pin down."},
      {name:"Pinene", short:"Pinene", family:"Pine", aroma:"Sharp pine & fresh forest", found:["Pine needles","Rosemary","Basil","Dill"], note:"Exactly what a walk through an evergreen forest smells like. Among the most common terpenes on Earth and prized for its crisp, clear-headed character."},
      {name:"Eucalyptol", short:"Eucalyptol", family:"Cooling", aroma:"Cool, minty camphor", found:["Eucalyptus","Rosemary","Bay leaves","Sage"], note:"The crisp, cooling note behind eucalyptus oil and countless balms. Also called cineole, it lends a fresh, breathable quality to an aroma."},
      {name:"Borneol", short:"Borneol", family:"Herbal", aroma:"Herbal, minty, camphor", found:["Rosemary","Camphor","Mint"], note:"Used for centuries in traditional aromatics and balms. It carries a cool, medicinal-herb quality that reads as clean and grounding."},
      {name:"Camphene", short:"Camphene", family:"Woodland", aroma:"Damp fir & forest floor", found:["Fir needles","Cypress","Nutmeg"], note:"An earthy, resinous evergreen aroma often mistaken for myrcene. Think fresh-cut conifer and cool damp woodland."},
      {name:"Delta-3-Carene", short:"Δ-3-Carene", family:"Pine", aroma:"Sweet pine & cypress", found:["Cypress","Pine","Rosemary","Bell pepper"], note:"A dry, sweet, resinous evergreen note. It adds a sappy, cedar-like edge that rounds out sharper pine terpenes."},
      {name:"Nerolidol", short:"Nerolidol", family:"Woody", aroma:"Woody, citrus, soft floral", found:["Jasmine","Tea tree","Lemongrass","Ginger"], note:"A gentle, relaxing aroma common in night-blooming flowers. Its soft woody-floral character makes it a mainstay of fine fragrance."},
      {name:"Linalool", short:"Linalool", family:"Floral", aroma:"Floral lavender & soft spice", found:["Lavender","Coriander","Birch"], note:"The signature scent of lavender. One of the most recognizable floral terpenes and long associated with a calm, restful mood."},
      {name:"Bisabolol", short:"Bisabolol", family:"Floral", aroma:"Soft, sweet chamomile", found:["Chamomile","Candeia tree"], note:"Prized in skincare for its gentle, soothing scent. A delicate, powdery-floral note that reads as soft and calming."},
      {name:"Geraniol", short:"Geraniol", family:"Floral", aroma:"Sweet rose & geranium", found:["Roses","Geraniums","Lemongrass"], note:"A classic rose note used widely in perfumery. It brings a sweet, dewy floral character wherever it appears."},
      {name:"Phytol", short:"Phytol", family:"Green", aroma:"Balsamic, green, floral", found:["Green tea","Leafy greens"], note:"A breakdown product of chlorophyll — part of the fresh, grassy character of green tea. Subtle, balsamic and softly floral."},
      {name:"Humulene", short:"Humulene", family:"Earthy", aroma:"Hoppy, earthy, woody", found:["Hops","Sage","Ginseng","Basil"], note:"Shares its origin with the earthy, bitter note in beer hops. Warm, woody and unmistakably 'green' in the herbal sense."},
      {name:"Myrcene", short:"Myrcene", family:"Earthy", aroma:"Earthy, musky, clove", found:["Mango","Lemongrass","Hops","Thyme"], note:"Typically the most abundant terpene in cannabis. Its warm, musky, slightly sweet aroma anchors many familiar strains."},
      {name:"Caryophyllene", short:"Caryophyllene", family:"Spicy", aroma:"Peppery, spicy, warm wood", found:["Black pepper","Cloves","Cinnamon"], note:"Unique among terpenes: its structure lets it interact with the body's endocannabinoid (CB2) receptors — the only terpene known to do so. It's the bite in freshly cracked black pepper."}
    ];

    var CANNA_URL="https://levelexperience.shop/pages/cannabinoids-targeted-benefits";

    root.innerHTML =
      '<p class="terp__eyebrow">Interactive &middot; Aroma Wheel</p>'+
      '<h2 class="terp__title">A Wide Spectrum of Aroma</h2>'+
      '<p class="terp__lede">Terpenoids are the aromatic compounds that give every plant its scent &mdash; and they show up far beyond cannabis, in the citrus, pine, lavender and pepper you already know. Hover or tap a wedge to explore each one.</p>'+
      '<p class="terp__did"><b>Did you know</b>Terpenes are the simplest members of the terpenoid family. The two words are often used interchangeably, but &ldquo;terpenoids&rdquo; is the broader umbrella that also includes their oxygen-carrying cousins &mdash; so that&rsquo;s what we call them here.</p>'+
      '<div class="terp__stage">'+
        '<div class="terp__wheelwrap"><svg class="terp__svg" viewBox="0 0 720 640" role="group" aria-label="Interactive terpene wheel"></svg></div>'+
        '<aside class="terp__panel" aria-live="polite">'+
          '<div class="terp__ptop"><span class="terp__dot" data-dot></span><div>'+
            '<h3 class="terp__pname" data-pname>Explore the wheel</h3>'+
            '<p class="terp__family" data-pfam>16 terpenoids &middot; LEVEL spectrum</p>'+
          '</div></div>'+
          '<p class="terp__aroma" data-paroma><span class="terp__hint">Hover a wedge to reveal its aroma, its botanical relatives, and what makes it distinct.</span></p>'+
          '<div data-pdetail hidden>'+
            '<p class="terp__lab">Also found in</p>'+
            '<div class="terp__chips" data-pchips></div>'+
            '<p class="terp__lab" style="margin-top:14px">Good to know</p>'+
            '<p class="terp__note" data-pnote></p>'+
          '</div>'+
        '</aside>'+
      '</div>'+
      '<div class="terp__foot">'+
        '<div class="terp__cta">'+
          '<p class="terp__ctatxt">Terpenoids are only half the story. <span>See how individual cannabinoids target specific effects like sleep, calm, focus and recovery.</span></p>'+
          '<a class="terp__btn" href="'+CANNA_URL+'">Explore the Cannabinoids Guide '+
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>'+
          '</a>'+
        '</div>'+
        '<p class="terp__disc">For education only. Aromas, botanical sources and research context are illustrative and are not health, medical, or product claims. Terpene profiles vary by plant, cultivar and batch.</p>'+
      '</div>';

    // ---- LEVEL brand spectrum, interpolated into 16 stops ----
    var ANCHORS = ["#ffb548","#81e77a","#2ed9c3","#19bde8","#00a0df","#7473c0","#8a84d6","#ff675d","#f68d6c"];
    function hx(c){return [parseInt(c.slice(1,3),16),parseInt(c.slice(3,5),16),parseInt(c.slice(5,7),16)];}
    function toHex(a){return "#"+a.map(function(v){var s=Math.max(0,Math.min(255,Math.round(v))).toString(16);return s.length<2?"0"+s:s;}).join("");}
    function loopColors(anchors,n){
      var out=[],m=anchors.length;
      for(var i=0;i<n;i++){
        var t=i/n*m, k=Math.floor(t), f=t-k;
        var a=hx(anchors[k%m]), b=hx(anchors[(k+1)%m]);
        out.push(toHex([a[0]+(b[0]-a[0])*f, a[1]+(b[1]-a[1])*f, a[2]+(b[2]-a[2])*f]));
      }
      return out;
    }
    var COLORS = loopColors(ANCHORS, TERPENES.length);

    // ---- geometry ----
    var NS="http://www.w3.org/2000/svg";
    var CX=360, CY=320, R_OUT=224, R_IN=132, R_LBL=250, GAP=0.016;
    var N=TERPENES.length, STEP=2*Math.PI/N;
    var svg=root.querySelector('.terp__svg');

    function pol(r,a){return [CX+r*Math.cos(a), CY+r*Math.sin(a)];}
    function sector(a0,a1,ri,ro){
      var p0=pol(ro,a0),p1=pol(ro,a1),p2=pol(ri,a1),p3=pol(ri,a0);
      var large=(a1-a0)>Math.PI?1:0;
      return "M"+p0[0]+" "+p0[1]+"A"+ro+" "+ro+" 0 "+large+" 1 "+p1[0]+" "+p1[1]+
             "L"+p2[0]+" "+p2[1]+"A"+ri+" "+ri+" 0 "+large+" 0 "+p3[0]+" "+p3[1]+"Z";
    }

    var segEls=[], lblEls=[];
    TERPENES.forEach(function(t,i){
      var a0=-Math.PI/2 + i*STEP + GAP/2;
      var a1=-Math.PI/2 + (i+1)*STEP - GAP/2;
      var mid=(a0+a1)/2;

      var g=document.createElementNS(NS,"g");
      g.setAttribute("class","terp__seg");
      g.setAttribute("tabindex","0");
      g.setAttribute("role","button");
      g.setAttribute("aria-label",t.name+", "+t.family+" aroma");
      g.dataset.dx=Math.cos(mid)*13; g.dataset.dy=Math.sin(mid)*13;

      var path=document.createElementNS(NS,"path");
      path.setAttribute("d",sector(a0,a1,R_IN,R_OUT));
      path.setAttribute("fill",COLORS[i]);
      g.appendChild(path);
      svg.appendChild(g);

      var lp=pol(R_LBL,mid);
      var lbl=document.createElementNS(NS,"text");
      lbl.setAttribute("class","terp__lbl");
      lbl.setAttribute("x",lp[0]); lbl.setAttribute("y",lp[1]);
      var cos=Math.cos(mid);
      lbl.setAttribute("text-anchor", cos>0.2?"start":(cos<-0.2?"end":"middle"));
      lbl.setAttribute("dominant-baseline","middle");
      lbl.textContent=t.short;
      svg.appendChild(lbl);

      segEls.push(g); lblEls.push(lbl);

      g.addEventListener("mouseenter",function(){select(i,false);});
      g.addEventListener("focus",function(){select(i,false);});
      g.addEventListener("click",function(){select(i,true);});
      g.addEventListener("keydown",function(e){
        if(e.key==="Enter"||e.key===" "){e.preventDefault();select(i,true);}
        else if(e.key==="ArrowRight"||e.key==="ArrowDown"){e.preventDefault();segEls[(i+1)%N].focus();}
        else if(e.key==="ArrowLeft"||e.key==="ArrowUp"){e.preventDefault();segEls[(i-1+N)%N].focus();}
      });
    });

    // ---- hub: official LEVEL staircase mark (exact favicon silhouette) ----
    var hub=document.createElementNS(NS,"g");
    var hc=document.createElementNS(NS,"circle");
    hc.setAttribute("cx",CX);hc.setAttribute("cy",CY);hc.setAttribute("r",R_IN-10);
    hc.style.fill="var(--tw-hub)";hc.style.stroke="var(--tw-hub-ring)";hc.setAttribute("stroke-width","1.5");
    hub.appendChild(hc);

    var mark=document.createElementNS(NS,"path");
    mark.setAttribute("d","M0 0 H32 V32 H23 V21 H11 V9 H0 Z");
    var f=2.6, ox=CX-16*f, oy=CY-18-16*f;
    mark.setAttribute("transform","translate("+ox+" "+oy+") scale("+f+")");
    mark.style.fill="var(--tw-mark)";
    hub.appendChild(mark);

    var hname=document.createElementNS(NS,"text");
    hname.setAttribute("class","terp__hubname");
    hname.setAttribute("x",CX);hname.setAttribute("y",CY+66);hname.setAttribute("text-anchor","middle");
    hname.setAttribute("font-size","19");
    hub.appendChild(hname);
    svg.appendChild(hub);

    // ---- panel refs ----
    var pdot=root.querySelector('[data-dot]'),
        pname=root.querySelector('[data-pname]'),
        pfam=root.querySelector('[data-pfam]'),
        paroma=root.querySelector('[data-paroma]'),
        pdetail=root.querySelector('[data-pdetail]'),
        pchips=root.querySelector('[data-pchips]'),
        pnote=root.querySelector('[data-pnote]');

    var locked=-1;
    function clear(){
      root.classList.remove("is-active");
      segEls.forEach(function(g,k){g.classList.remove("on");g.style.transform="translate(0,0)";lblEls[k].classList.remove("on");});
      pdot.style.background="var(--tw-accent)";
      pname.textContent="Explore the wheel";
      pfam.textContent=N+" terpenoids · LEVEL spectrum";
      paroma.innerHTML='<span class="terp__hint">Hover a wedge to reveal its aroma, its botanical relatives, and what makes it distinct.</span>';
      pdetail.hidden=true;
      hname.textContent="";
    }
    function select(i,lock){
      if(lock){ if(locked===i){ locked=-1; clear(); return; } locked=i; }
      var t=TERPENES[i], c=COLORS[i];
      root.classList.add("is-active");
      segEls.forEach(function(g,k){
        var on=k===i;
        g.classList.toggle("on",on);
        lblEls[k].classList.toggle("on",on);
        g.style.transform = on ? "translate("+g.dataset.dx+"px,"+g.dataset.dy+"px)" : "translate(0,0)";
      });
      pdot.style.background=c;
      pname.textContent=t.name;
      pfam.textContent=t.family+" family";
      paroma.textContent=t.aroma;
      pchips.innerHTML="";
      t.found.forEach(function(x){var s=document.createElement("span");s.className="terp__chip";s.textContent=x;pchips.appendChild(s);});
      pnote.textContent=t.note;
      pdetail.hidden=false;
      hname.textContent=t.name;
    }

    svg.addEventListener("mouseleave",function(){ if(locked>-1){ select(locked,false); } else { clear(); } });
  }

  if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded",init); }
  else { init(); }
})();
